import React, {Component} from "react";
import {titleCase} from "../../Utilities/StringUtils";
import Button from "@material-ui/core/Button";
import {CloseButton} from "../../Common/Buttons";
import { eventTemplatesConfig } from "../../../Backend/clubDetails";

/**
 * Responsible for loading project-specific event templates
 */
export class NewEventsLoadTemplate extends Component {
    
    getTemplateNames() {
        // Default templates if no configuration is available
        const defaultTemplates = ['custom'];
        
        // If no templates config exists, return default
        if (!eventTemplatesConfig || !eventTemplatesConfig.templates) {
            return defaultTemplates;
        }
        
        // Get enabled templates from configuration
        const templates = eventTemplatesConfig.templates;
        const enabledTemplates = Object.keys(templates)
            .filter(name => templates[name].enabled)
            .sort(); // Sort template names alphabetically
            
        // Custom template should always be available and listed last
        return enabledTemplates.filter(name => name !== 'custom').concat(['custom']);
    }
    
    formatTemplateName(name) {
        // You can customize this to use any display names defined in the config
        return titleCase(name.replace(/_/g, ' '));
    }

    render(){
        const buttonStyle={width: 240, margin: 5};
        const templateNames = this.getTemplateNames();
        
        return (
            <div style={{margin: 0, padding: 0, display: 'inline'}}>
                <CloseButton onClick={()=>this.props.onExit()}/>
                <h2 style={{display: 'inline', margin: 0, padding: 0}}>Choose Events Template</h2>
                <br /><br />

                <div align="center">
                    {templateNames.map(template => {
                        return (
                            <Button variant="contained"
                                    key={template}
                                    color={template === "custom" ? "default":"primary"}
                                    style={buttonStyle}
                                    onClick={()=>this.props.onSelect(template)}>
                                {this.formatTemplateName(template)}
                            </Button>);
                    })}
                </div>
            </div>
        );
    }
}
